export const isInsideGoReactNativeApp = () => window.ReactNativeWebView && window.isRNGoApp;

function blobToBase64(blob) {
    return new Promise(resolve => {
        const reader = new window.FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export async function transferFileToNative(binaryPayload, filename) {
    const base64payload = await blobToBase64(binaryPayload);
    window.ReactNativeWebView.postMessage(
        JSON.stringify({
            downloadFile: { base64payload, filename }
        })
    );
}
